import { RouteUrlList } from '@/libs/RouteList';

/**
 * @todo 基本身份驗證 PostBack
 */
const UserAuthPostBack = [
    'POST',
    RouteUrlList.API_UserAuthPostBack.path,
    {},
    200,
    {
        status: true,
        title: '',
        message: '',
        errorCode: '',
        reject: false,
        completed: false
    }
];
export default UserAuthPostBack;
